import React, { useEffect, useState } from "react";

// A file input that shows a preview of the selected image before upload,
// falling back to an existing image (edit mode) when no new file is chosen
// yet. Non-image accept types (e.g. PDF) render with no preview.
const FileInputPreview = ({
  registerProps,
  accept = "image/*",
  existingImageUrl = null,
  wrapperClassName = "",
  inputClassName,
  previewClassName = "mb-3 h-20 w-20 rounded-lg object-cover",
  disabled = false,
  children,
}) => {
  const isImage = accept.includes("image");
  const [previewUrl, setPreviewUrl] = useState(existingImageUrl);

  useEffect(() => {
    setPreviewUrl(existingImageUrl);
  }, [existingImageUrl]);

  useEffect(() => {
    // Revoke any object URL we created for a chosen file when it's replaced
    // or the component unmounts, to avoid leaking memory.
    return () => {
      if (previewUrl && previewUrl.startsWith("blob:")) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const handleChange = (e) => {
    registerProps?.onChange?.(e);
    const file = e.target.files?.[0];
    if (file && isImage) {
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  return (
    <div className={wrapperClassName}>
      {isImage && previewUrl && (
        <img src={previewUrl} alt="" className={previewClassName} />
      )}
      <input
        type="file"
        accept={accept}
        disabled={disabled}
        {...registerProps}
        onChange={handleChange}
        className={inputClassName}
      />
      {children}
    </div>
  );
};

export default FileInputPreview;
